import { Button, DatePicker, InputNumber, Modal, notification, Select, Upload } from "antd"
import Form from "antd/es/form/Form"
import Input from "antd/es/input/Input"
import Title from "antd/es/typography/Title"
import { CreateRetreat } from "../../../api/AdminService"
import { useNavigate } from "react-router-dom"
import dayjs from "dayjs"
import { Option } from "antd/es/mentions"
import { ArrowLeftOutlined, MinusCircleOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons"
import { CreateDish, GetAllDishTypes } from "../../../api/MonkService"
import { useEffect, useState } from "react"
const MonkAddDish = ({ open, onClose, onSuccess }) => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);
    const [dishType, setDishType] = useState([]);

    const GetRoomType = () => {
        GetAllDishTypes().then(res => {
            if (res.status === 200) {
                console.log(res.data.data)
                setDishType(res.data.data)
            }
        })
    }

    useEffect(() => {
        GetRoomType();
    }, [])

    const onFinish = (values) => {
        setLoading(true);
        const formData = new FormData();
        formData.append('dishTypeName', values.dishTypeName);
        formData.append('name', values.name);
        formData.append('note', values.note);

        CreateDish(formData).then(res => {
            if (res.status === 201) {
                console.log(res);
                notification.success({
                    message: "Created Dish Successfully"
                });
                setLoading(false);
                onSuccess();
                onClose();
            }
        }).catch(err => {
            console.log(err.response);
            notification.error({
                message: `${err.response.data.message}`
            });
            setLoading(false);
        });
    }


    return (
        <Modal
            open={open}
            title="Create Dish"
            onCancel={onClose}
            footer={[]}
        >
            <Form
                onFinish={onFinish}
            >
                <Form.Item name={"dishTypeName"} label="Dish Type"
                    rules={[
                        {
                            required: true,
                            message: 'Requiring type',
                        },
                    ]}
                >
                    <Select
                        placeholder="Choose Dish Type"
                    >
                        {dishType.map((item) => (
                            <Option key={item.id} value={item.name}>
                                {item.name}
                            </Option>
                        ))}

                    </Select>
                </Form.Item>
                <Form.Item name={"name"} label="Name" rules={[{ required: true, message: 'Requiring Name' }]}>
                    <Input style={{ width: '100%' }}
                        placeholder="Input Food Name"
                    />
                </Form.Item>
                <Form.Item name={"note"} label="Note" rules={[{ required: true, message: 'Requiring Note' }]}>
                    <Input style={{ width: '100%' }}
                        placeholder="Input Note"
                    />
                </Form.Item>
                <Form.Item >
                        <Button block type="primary" htmlType="submit" loading={loading}>
                            {loading ? "Loading" : "Save"}
                        </Button>
                    </Form.Item>
            </Form>
        </Modal>


    )

}
export default MonkAddDish